export var includesSearchValue = function(field, searchValue) {
    return field.toLowerCase().includes(searchValue.toLowerCase());
};
